import axios from 'axios';

const hostMap = {
  '.sitebuilder-publication.kub.app.builderall.io': {
    altcha: 'https://captcha.kub.app.builderall.io'
  },
  '.sitebuilder-publication.kub.app.builderall.info': {
    altcha: 'https://captcha.kub.app.builderall.info'
  },
  'default': {
    altcha: 'https://captcha.services.builderall.com'
  }
};




const getAltchaBaseUrl = () => {
  const host = window.location.host;
  const foundKey = Object.keys(hostMap).find(key => 
    key !== 'default' && host.includes(key)
  );
  
  const config = hostMap[foundKey] || hostMap['default'];
  return config.altcha;
};

const formatLocale = lang => {
  const localeMap = {
      'en': 'en',
      'pt': 'pt-br',
      'es': 'es-es',
      'de': 'de',
      'it': 'it',
      'fr': 'fr-fr'
  };
  
  const langCode = lang.slice(0, 2).toLowerCase();
  return localeMap[langCode] || 'en';
}

const loadTranslationScript = () => {
  if (!document.getElementById('altcha-lang-loader')) {
    let language = document.documentElement.lang || navigator.language || navigator.userLanguage;
    let languageCode = formatLocale(language.toLowerCase());

    const script = document.createElement('script');
    script.id = 'altcha-lang-loader'
    script.src = `https://cdn.jsdelivr.net/gh/altcha-org/altcha/dist_i18n/${languageCode}.min.js`;
    script.type = 'module';
    document.head.appendChild(script);
  }
}

export const loadAltcha = () => {

  // load translator
  loadTranslationScript()

  const baseURL = getAltchaBaseUrl();

  const altchaApi = axios.create({
    baseURL,
    timeout: 300000,
    headers: {
      'Accept': 'application/json'
    }
  });

  return altchaApi.get('/altcha');
};
